<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs8>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>
    <v-layout row v-if="$store.getters.user !== null">
      <v-flex xs4 class="ml-3">
        <v-text-field
            label="Поиск"
            append-icon="search"
            class="mr-3"
            @input="onSearch()"
            v-model="search"
            outline
        ></v-text-field>
      </v-flex>
      <v-flex xs4 v-if="$store.getters.user.branch === null">
        <v-select
            :items="branchTitleList"
            label="Филиал"
            v-model="branch"
            class="mr-3"
            @input="onBranchSelect()"
            outline
            no-data-text="Нет данных"
        ></v-select>
      </v-flex>
      <v-flex xs4 v-if="isAccess(10)">
        <v-select
            :items="userGroupTitles"
            label="Группа"
            v-model="userGroup"
            class="mr-3"
            @input="onUserGroupSelect()"
            outline
            no-data-text="Нет данных"
        ></v-select>
      </v-flex>
    </v-layout>

    <div v-if="userList !== null">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="userList"
                hide-actions
                class="elevation-1"
                no-data-text="Пользователи не найдены"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <v-avatar class="my-2">
                    <img :src="props.item.photo.url_resized">
                  </v-avatar>
                </td>
                <td class="text-xs-left">
                  <span class="ma-0 cursor-pointer" @click="$router.push('/users/single/' + props.item.id)">{{ props.item.surname }} {{ props.item.first_name }} {{ props.item.patronymic }}</span>
                </td>
                <td class="text-xs-left">{{ props.item.branch !== null ? props.item.branch.title : ''}}</td>
                <td class="text-xs-left">{{ props.item.user_group !== null ? props.item.user_group.title : ''}}</td>
                <td class="text-xs-left">
                  <v-text-field
                      class="ma-0 user-list-masked-input"
                      :value="props.item.phone"
                      mask="+7 (###) ###-##-##"
                      disabled
                  ></v-text-field>
                </td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ pointCount(props.item) }}</td>
                <td class="text-xs-left">
                  <div v-if="mode === 'active'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="editUser(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="deleteUser(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                  <div v-if="mode === 'archive'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="activeUser(props.item.id)"
                        color="primary"
                    >
                      <v-icon>check_box</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'active'"
    >
      <v-card>
        <v-card-title class="headline">Удалить пользователя?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteUserConfirm(deleteUserId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteUserCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="activeDialog"
        max-width="300"
        v-if="mode === 'archive'"
    >
      <v-card>
        <v-card-title class="headline">Активировать пользователя?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary"
              @click="activeUserConfirm(activeUserId)"
          >
            Активировать
          </v-btn>

          <v-btn
              @click="activeUserCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Пользователи'}
        ],
        headers: [
          {
            text: 'Фото',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'ФИО',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Филиал',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Группа',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Телефон',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Email',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Кол-во торговых точек',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          userList: false,
          userGroupList: false,
          branchList: false
        },
        page: 1,
        mode: 'active',
        title: 'Активные пользователи',
        deleteDialog: false,
        deleteUserId: null,
        activeDialog: false,
        activeUserId: null,
        search: null,
        branch: null,
        branchId: null,
        userGroup: null,
        userGroupId: null,
        userGroupTitles: []
      }
    },
    methods: {
      isAccess (accessId) {
        if (typeof this.$store.getters.user.user_group.access_list !== 'undefined') {
          if (Array.isArray(accessId)) {
            for (let i = 0; i < accessId.length; i++) {
              for (let k = 0; k < this.$store.getters.user.user_group.access_list.length; k++) {
                if (accessId[i] === this.$store.getters.user.user_group.access_list[k].id) {
                  return true
                }
              }
            }
          } else {
            for (let i = 0; i < this.$store.getters.user.user_group.access_list.length; i++) {
              if (accessId === this.$store.getters.user.user_group.access_list[i].id) {
                return true
              }
            }
          }
        }
        return false
      },
      pageDataStatus () {
        if (!this.pageDataReady.userList) {
          return false
        }
        if (!this.pageDataReady.userGroupList) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
        } else {
          this.branchId = null
        }
        this.updateUrl()
      },
      onUserGroupSelect () {
        if (this.userGroup !== null && this.userGroup !== 'Все группы') {
          for (let i = 0; i < this.userGroupList.length; i++) {
            if (this.userGroupList[i].title === this.userGroup) {
              this.userGroupId = this.userGroupList[i].id
              break
            }
          }
        } else {
          this.userGroupId = null
        }
        this.updateUrl()
      },
      onSearch () {
        this.updateUrl()
      },
      updateUrl () {
        let filter = ''
        if (this.search !== null && this.search !== '') {
          filter += '?q=' + this.search
        }
        if (this.branchId !== null) {
          if (filter === '') {
            filter += '?branch_id=' + this.branchId
          } else {
            filter += '&branch_id=' + this.branchId
          }
        }
        if (this.userGroupId !== null) {
          if (filter === '') {
            filter += '?user_group_id=' + this.userGroupId
          } else {
            filter += '&user_group_id=' + this.userGroupId
          }
        }

        if (this.mode === 'active') {
          this.$router.push('/users/active/1' + filter)
        } else if (this.mode === 'archive') {
          this.$router.push('/users/past/1' + filter)
        }
      },
      changePage () {
        this.scrollUp()

        this.pageDataReady = {
          isReady: false,
          userList: false,
          userGroupList: false,
          branchList: false
        }
        this.$store.commit('setPageLoading', true)

        if (this.mode === 'active') {
          this.$router.push('/users/active/' + this.page)
        } else if (this.mode === 'archive') {
          this.$router.push('/users/past/' + this.page)
        } else {
          this.$store.dispatch('getUserList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
        }
      },
      editUser (id) {
        this.$router.push('/users/edit/' + id)
      },
      deleteUser (id) {
        this.deleteDialog = true
        this.deleteUserId = id
      },
      deleteUserCancel () {
        this.deleteDialog = false
        this.deleteUserId = null
      },
      deleteUserConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteUser', {id: this.deleteUserId})
        this.deleteUserId = null
        this.$store.dispatch('getUserList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      activeUser (id) {
        this.activeDialog = true
        this.activeUserId = id
      },
      activeUserCancel () {
        this.activeDialog = false
        this.activeUserId = null
      },
      activeUserConfirm () {
        this.activeDialog = false
        this.$store.dispatch('activeUser', {id: this.activeUserId})
        this.activeUserId = null
        this.$store.dispatch('getUserList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/users/active')) {
          this.mode = 'active'
          this.title = 'Активные пользователи'
        } else if (~this.$router.currentRoute.path.indexOf('/users/past')) {
          this.mode = 'archive'
          this.title = 'Архив пользователей'
        }

        if (typeof this.$router.currentRoute.query.q !== 'undefined') {
          this.search = this.$router.currentRoute.query.q
        }
        if (typeof this.$router.currentRoute.query.user_group_id !== 'undefined') {
          this.userGroupId = this.$router.currentRoute.query.user_group_id
        }
        if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
          this.branchId = this.$router.currentRoute.query.branch_id
        }

        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getUserList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10, search: this.search, userGroupId: this.userGroupId, branchId: this.branchId})
          .then(() => {
            this.pageDataReady.userList = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getUserGroupList')
          .then(() => {
            this.pageDataReady.userGroupList = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getBranchList')
          .then(() => {
            this.pageDataReady.branchList = true
            this.pageDataStatus()
          })
      },
      pointListByPointFolderList (pointFolderList) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            let list = this.pointListByPointFolderList(pointFolderList[i].point_folder_list)
            resultList = resultList.concat(list)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              resultList.push(pointFolderList[i].point_list[j].id)
            }
          }
        }
        return resultList
      },
      pointCount (user) {
        let pointIdList = []
        if (typeof user.point_folder_tree !== 'undefined' && user.point_folder_tree !== null) {
          pointIdList = this.pointListByPointFolderList(user.point_folder_tree)
        }
        return pointIdList.length
      }
    },
    computed: {
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      userGroupList () {
        return this.$store.getters.userGroupList
      },
      userGroupTitleList () {
        return this.$store.getters.userGroupTitleList
      },
      userList () {
        return this.$store.getters.userList
      },
      totalCount () {
        return this.$store.getters.userTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      userGroupTitleList (val) {
        this.userGroupTitles = ['Все группы']

        for (let i = 0; i < this.userGroupTitleList.length; i++) {
          this.userGroupTitles[this.userGroupTitles.length] = this.userGroupTitleList[i]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserList.vue